import { Data } from '@angular/router/src/config';
import { ResumoHomologacaoCurso } from './resumo-homologacao.model'

export class Homologacao {
    
    public id: number;
    public id_situacao: number;
    
    public id_usuario_receptor?: number;
    public nome_perfil_receptor?: string;
    public nome_pendencia_receptor?:string
    public resumo_homologacao: ResumoHomologacaoCurso[];
   
}



// WEBPACK FOOTER //
// ./src/app/entity/homologacao.ts